export const API_PREFIX: string = "rpc/api/";
export const API_ACTION_PREFIX: string = "rpc/portal/action";
export const API_USER_NOTIFICATION_ROUTE: string =
  "rpc/utils/user-notification";
export const API_APP_USER_PREFIX: string = "rpc/portal/app-user";
export const API_APP_USER_PERMISSION_PREFIX: string =
  "rpc/portal/app-user-permission";
export const API_APP_USER_ROLE_MAPPING_PREFIX: string =
  "rpc/portal/app-user-role-mapping";
export const API_APP_USER_SESSION_PREFIX: string =
  "rpc/portal/app-user-session";
export const API_APP_USER_SITE_MAPPING_PREFIX: string =
  "rpc/portal/app-user-site-mapping";
export const API_LDAP_CONFIGURATION_PREFIX: string =
  "rpc/portal/ldap-configuration";
export const API_ORGANIZATION_PREFIX: string = "rpc/portal/organization";
export const API_PERMISSION_PREFIX: string = "rpc/portal/permission";
export const API_PERMISSION_FIELD_MAPPING_PREFIX: string =
  "rpc/portal/permission-field-mapping";
export const API_PERMISSION_OPERATOR_PREFIX: string =
  "rpc/portal/permission-operator";
export const API_PROVIDER_PREFIX: string = "rpc/portal/provider";
export const API_ROLE_PREFIX: string = "rpc/portal/role";
export const API_SITE_PREFIX: string = "rpc/portal/site";
export const API_THEME_PREFIX: string = "rpc/portal/theme";
export const API_DISTRICT_PREFIX: string = "rpc/portal/district";
export const API_PROVINCE_PREFIX: string = "rpc/portal/province";
export const API_WARD_PREFIX: string = "rpc/portal/ward";
export const API_NATION_PREFIX: string = "rpc/portal/nation";
export const API_WORKFLOW_DEFINITION_PREFIX: string =
  "rpc/portal/workflow-definition";
export const API_WORKFLOW_DIRECTION_CONDITION_PREFIX: string =
  "rpc/portal/workflow-direction-condition";
export const API_WORKFLOW_DIRECTION_PREFIX: string =
  "rpc/portal/workflow-direction";
export const API_WORKFLOW_OPERATOR_PREFIX: string =
  "rpc/portal/workflow-operator";
export const API_WORKFLOW_PARAMETER_PREFIX: string =
  "rpc/portal/workflow-parameter";
export const API_WORKFLOW_PARAMETER_TYPE_PREFIX: string =
  "rpc/portal/workflow-parameter-type";
export const API_WORKFLOW_STATE_PREFIX: string = "rpc/portal/workflow-state";
export const API_WORKFLOW_STEP_PREFIX: string = "rpc/portal/workflow-step";
export const API_WORKFLOW_TYPE_PREFIX: string = "rpc/portal/workflow-type";
export const API_INIT_PREFIX: string = "rpc/portal/init-data";
export const API_PROFILE_PREFIX: string = "rpc/portal/profile";
export const API_LOGIN_CONFIGURATION_PREFIX: string =
  "rpc/portal/login-configuration";
export const API_APP_USER_GROUPING_PREFIX: string =
  "rpc/portal/app-user-grouping";
export const API_REGION_PREFIX: string = "rpc/portal/region";
export const API_POSITION_PREFIX: string = "rpc/portal/position";
export const API_FILE_TEMPLATE_PREFIX: string = "rpc/portal/file-template";
export const API_MENU_REPORT_PREFIX: string = "rpc/portal/menu-report";
